import instance from '@/api/business' 
import { Customer, CustomerUpdateProps } from './type'

const BASE_URL = '/customer/crweb/customer'

export const fetchCustomer = async () => {
    const response = await instance.post<Customer[]>(BASE_URL)

    return response.data
}

export const updateCustomer = async (data: CustomerUpdateProps) => {
    const response = await instance.patch(BASE_URL, data)

    return response.data
}

